import { Card, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { type TradeInModuleSpecsFragment } from '../../../../api/fragments/TradeInModuleSpecs';

type TradeInModuleAuthorizationPageProps = {
    module: TradeInModuleSpecsFragment;
};

const TradeInModuleAuthorization = ({ module }: TradeInModuleAuthorizationPageProps) => {
    const { t } = useTranslation(['tradeInModuleDetails']);

    const { authorization } = module;

    return (
        <Card>
            <Descriptions column={{ xs: 1, md: 2 }} bordered>
                <Descriptions.Item label={t('tradeInModuleDetails:tabs.authorization.descriptions.accessKey')}>
                    {authorization.accessKey}
                </Descriptions.Item>
                <Descriptions.Item label={t('tradeInModuleDetails:tabs.authorization.descriptions.secretKey')}>
                    {authorization.secretKey}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default TradeInModuleAuthorization;
